import { thirdData } from "./landingPageConstant";
import { Link } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";

export default function Three() {
  const content = (
    <section className="w-[90%]  my-[2.5rem]   mx-auto">
      <h3>Important Service Update</h3>
      <p>Service bulletins keep you up to date with news and alerts</p>
      <hr className="w-[20%] p-[0.01rem] bg-black " />
      <div>
        <ul className="grid grid-cols-1 md:grid-cols-2  gap-[1rem]">
          {thirdData.map((data) => (
            <li
              key={data.id}
              className="    flex flex-col gap-[1rem] my-[1rem]"
            >
              <div className="   bg-white  shadow-md shadow-gray-400   ">
                <img
                  src={data.imgUrl}
                  alt="newest"
                  className="w-full  h-[24rem]  xl:h-[35rem]  "
                />
                <Link className="text-[1rem] flex pl-[0.5rem]  font-bold my-[0.7rem] tracking-wide">
                  {data.title}{" "}
                  <RiArrowRightSLine className="inline-block my-auto  ml-[0.6rem] text-[1.3rem] text-red-500" />
                </Link>
                <hr className="w-[20%]  pl-[0.5rem]  bg-yellow-600 " />
                <p className=" w-[97%] lg:w-[90%]   p-[0.6rem]  text-gray-500 font-thin  my-[0.5rem]">
                  {data.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );

  return content;
}
